var render = function (_h,_vm) {var _c=_vm._c;return _c('Button',_vm._g(_vm._b({staticClass:"close-button",class:_vm.data.staticClass,attrs:{"type":"button"}},'Button',_vm.data.attrs,false),_vm.listeners),[_vm._t("default",[_vm._v("Close")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }